import FetchException from '../FetchException';

export default class FetchSearchResultsException extends FetchException {}
